import React from "react";
import { RideGlPlaneSolid } from "@rimac-seguros/ride-system-components"
import useBreakpoint from "@/hooks/useBreakpoint";
import { useSelector } from "react-redux";

export const ContentTravel = () => {
  const { experimentBenefits } = useSelector((state) => state.experiment);
  const isDesktop = useBreakpoint("large-min");
  const bannerTitle = experimentBenefits?.bannerTitle || "Compra tu seguro y participa por el sorteo de S/1,000";
  return (
    <section className="banner-benefits fly-travel">
      {isDesktop && <RideGlPlaneSolid fill="#fff" size="2x-large" />}
      <p>{bannerTitle}</p>
      {isDesktop && <RideGlPlaneSolid fill="#fff" size="2x-large" />}
    </section>
  );
};
